import moment from 'moment';
import { Expansion, ExpansionPatch } from '../expansion';
import { FAR_FUTURE_DATE } from '../sharedConstants';
import { RaidDifficulty } from '../sharedTypes';
import { CURRENT_TIER_RAID_KILLCOUNT, PREVIOUS_TIER_RAID_KILLCOUNT } from './constants';
import { TRaidMetadata } from './types';
import {
  DRAGON_SOUL_RELEASE_DATES,
  FIRELANDS_RELEASE_DATES,
  HEART_OF_FEAR_RELEASE_DATES,
  MISTS_OF_PANDARIA_RAID_RELEASE_DATES,
  SIEGE_OF_ORGRIMMAR_RELEASE_DATES,
  TERRACE_ENDLESS_SPRING_RELEASE_DATES,
  THRONE_OF_THUNDER_RELEASE_DATES
} from './dates';

// mapId comes from: https://wow.tools/dbc/?dbc=map (is mapId even used here? We should use what's in db i guess?)
export const RAID_METADATA: TRaidMetadata[] = [
  {
    name: 'Siege of Orgrimmar',
    short_name: 'SOO',
    slug: 'siege-of-orgrimmar',
    icon: 'achievement_boss_ironjuggernaut',
    mapId: 1136,
    tier: '16',
    ordinal: 14,
    numEncounters: 14,
    expansion: Expansion.MistsOfPandaria,
    supportedDifficulties: [
      RaidDifficulty.HEROIC_25,
      RaidDifficulty.HEROIC_10,
      RaidDifficulty.NORMAL_25,
      RaidDifficulty.NORMAL_10,
      RaidDifficulty.NORMAL
    ],
    patch: ExpansionPatch.Patch_540,
    membersNeededForKill: CURRENT_TIER_RAID_KILLCOUNT,
    supportsFactions: false,
    supportsWorldFirstTracker: false,
    supportsGlobalCoverage: false,
    supportsGraphs: false,
    supportsTalentTrees: true,
    leaderboardByBestPull: true,
    approximateDifficultySize: false,
    disabledRegions: ['cn'],
    starts: SIEGE_OF_ORGRIMMAR_RELEASE_DATES,
    ends: {
      us: FAR_FUTURE_DATE,
      eu: FAR_FUTURE_DATE,
      tw: FAR_FUTURE_DATE,
      kr: FAR_FUTURE_DATE,
      cn: FAR_FUTURE_DATE
    }
  },
  {
    name: 'Throne of Thunder',
    short_name: 'TOT',
    slug: 'throne-of-thunder',
    icon: 'archaeology_5_0_thunderkinginsignia',
    mapId: 1098,
    tier: '15',
    ordinal: 13,
    numEncounters: 13,
    expansion: Expansion.MistsOfPandaria,
    supportedDifficulties: [
      RaidDifficulty.HEROIC_25,
      RaidDifficulty.HEROIC_10,
      RaidDifficulty.NORMAL_25,
      RaidDifficulty.NORMAL_10
    ],
    patch: ExpansionPatch.Patch_520,
    membersNeededForKill: CURRENT_TIER_RAID_KILLCOUNT,
    supportsFactions: false,
    supportsWorldFirstTracker: false,
    supportsGlobalCoverage: false,
    supportsGraphs: false,
    supportsTalentTrees: true,
    leaderboardByBestPull: true,
    approximateDifficultySize: false,
    disabledRegions: ['cn'],
    starts: THRONE_OF_THUNDER_RELEASE_DATES,
    ends: SIEGE_OF_ORGRIMMAR_RELEASE_DATES
  },
  {
    name: 'Terrace of Endless Spring',
    short_name: 'TOES',
    slug: 'terrace-of-endless-spring',
    icon: 'achievement_raid_terraceofendlessspring01',
    mapId: 996,
    tier: '14',
    ordinal: 12,
    numEncounters: 4,
    expansion: Expansion.MistsOfPandaria,
    supportedDifficulties: [
      RaidDifficulty.HEROIC_25,
      RaidDifficulty.HEROIC_10,
      RaidDifficulty.NORMAL_25,
      RaidDifficulty.NORMAL_10
    ],
    patch: ExpansionPatch.Patch_500,
    membersNeededForKill: CURRENT_TIER_RAID_KILLCOUNT,
    supportsFactions: false,
    supportsWorldFirstTracker: false,
    supportsGlobalCoverage: false,
    supportsGraphs: false,
    supportsTalentTrees: true,
    leaderboardByBestPull: true,
    approximateDifficultySize: false,
    disabledRegions: ['cn'],
    starts: TERRACE_ENDLESS_SPRING_RELEASE_DATES,
    ends: THRONE_OF_THUNDER_RELEASE_DATES
  },
  {
    name: 'Heart of Fear',
    short_name: 'HOF',
    slug: 'heart-of-fear',
    icon: 'achievement_raid_mantidraid01',
    mapId: 1009,
    tier: '14',
    ordinal: 11,
    numEncounters: 6,
    expansion: Expansion.MistsOfPandaria,
    supportedDifficulties: [
      RaidDifficulty.HEROIC_25,
      RaidDifficulty.HEROIC_10,
      RaidDifficulty.NORMAL_25,
      RaidDifficulty.NORMAL_10
    ],
    patch: ExpansionPatch.Patch_500,
    membersNeededForKill: CURRENT_TIER_RAID_KILLCOUNT,
    supportsFactions: false,
    supportsWorldFirstTracker: false,
    supportsGlobalCoverage: false,
    supportsGraphs: false,
    supportsTalentTrees: true,
    leaderboardByBestPull: true,
    approximateDifficultySize: false,
    disabledRegions: ['cn'],
    starts: HEART_OF_FEAR_RELEASE_DATES,
    ends: THRONE_OF_THUNDER_RELEASE_DATES
  },
  {
    name: 'Mogu\'shan Vaults',
    short_name: 'MSV',
    slug: 'mogushan-vaults',
    icon: 'achievement_raid_secondhalfmogu',
    mapId: 1008,
    tier: '14',
    ordinal: 10,
    numEncounters: 6,
    expansion: Expansion.MistsOfPandaria,
    supportedDifficulties: [
      RaidDifficulty.HEROIC_25,
      RaidDifficulty.HEROIC_10,
      RaidDifficulty.NORMAL_25,
      RaidDifficulty.NORMAL_10
    ],
    patch: ExpansionPatch.Patch_500,
    membersNeededForKill: CURRENT_TIER_RAID_KILLCOUNT,
    supportsFactions: false,
    supportsWorldFirstTracker: false,
    supportsGlobalCoverage: false,
    supportsGraphs: false,
    supportsTalentTrees: true,
    leaderboardByBestPull: true,
    approximateDifficultySize: false,
    disabledRegions: ['cn'],
    starts: MISTS_OF_PANDARIA_RAID_RELEASE_DATES,
    ends: THRONE_OF_THUNDER_RELEASE_DATES
  },
  {
    name: 'Dragon Soul',
    short_name: 'DS',
    slug: 'dragon-soul',
    icon: 'inv_misc_demonsoul',
    mapId: 967,
    tier: '13',
    ordinal: 9,
    numEncounters: 8,
    expansion: Expansion.Cataclysm,
    supportedDifficulties: [
      RaidDifficulty.HEROIC_25,
      RaidDifficulty.HEROIC_10,
      RaidDifficulty.NORMAL_25,
      RaidDifficulty.NORMAL_10
    ],
    patch: ExpansionPatch.Patch_430,
    membersNeededForKill: CURRENT_TIER_RAID_KILLCOUNT,
    supportsFactions: false,
    supportsWorldFirstTracker: false,
    supportsGlobalCoverage: false,
    supportsGraphs: false,
    supportsTalentTrees: true,
    leaderboardByBestPull: true,
    approximateDifficultySize: true,
    disabledRegions: ['cn'],
    starts: DRAGON_SOUL_RELEASE_DATES,
    ends: MISTS_OF_PANDARIA_RAID_RELEASE_DATES
  },
  {
    name: 'Firelands',
    short_name: 'FL',
    slug: 'firelands',
    icon: 'achievement_zone_firelands',
    mapId: 720,
    tier: '12',
    ordinal: 8,
    numEncounters: 7,
    expansion: Expansion.Cataclysm,
    supportedDifficulties: [
      RaidDifficulty.HEROIC_25,
      RaidDifficulty.HEROIC_10,
      RaidDifficulty.NORMAL_25,
      RaidDifficulty.NORMAL_10
    ],
    patch: ExpansionPatch.Patch_420,
    membersNeededForKill: PREVIOUS_TIER_RAID_KILLCOUNT,
    supportsFactions: false,
    supportsWorldFirstTracker: false,
    supportsGlobalCoverage: false,
    supportsGraphs: false,
    supportsTalentTrees: true,
    leaderboardByBestPull: true,
    approximateDifficultySize: true,
    disabledRegions: ['cn'],
    starts: FIRELANDS_RELEASE_DATES,
    ends: DRAGON_SOUL_RELEASE_DATES
  },
  {
    name: 'The Bastion of Twilight',
    short_name: 'BoT',
    slug: 'the-bastion-of-twilight',
    icon: 'achievement_reputation_ogre',
    mapId: 671,
    tier: '11',
    ordinal: 7,
    numEncounters: 5,
    expansion: Expansion.Cataclysm,
    supportedDifficulties: [
      RaidDifficulty.HEROIC_25,
      RaidDifficulty.HEROIC_10,
      RaidDifficulty.NORMAL_25,
      RaidDifficulty.NORMAL_10
    ],
    patch: ExpansionPatch.Patch_400,
    membersNeededForKill: PREVIOUS_TIER_RAID_KILLCOUNT,
    supportsFactions: false,
    supportsWorldFirstTracker: false,
    supportsGlobalCoverage: false,
    supportsGraphs: false,
    supportsTalentTrees: true,
    leaderboardByBestPull: true,
    approximateDifficultySize: true,
    disabledRegions: ['cn'],
    starts: {
      us: moment.utc('2024-05-30T22:00:00'),
      eu: moment.utc('2024-05-30T22:00:00'),
      tw: moment.utc('2024-05-30T22:00:00'),
      kr: moment.utc('2024-05-30T22:00:00'),
      cn: moment.utc('2024-05-30T22:00:00')
    },
    ends: FIRELANDS_RELEASE_DATES
  },
  {
    name: 'Blackwing Descent',
    short_name: 'BD',
    slug: 'blackwing-descent',
    icon: 'achievement_boss_nefarion',
    mapId: 669,
    tier: '11',
    ordinal: 6,
    numEncounters: 6,
    expansion: Expansion.Cataclysm,
    supportedDifficulties: [
      RaidDifficulty.HEROIC_25,
      RaidDifficulty.HEROIC_10,
      RaidDifficulty.NORMAL_25,
      RaidDifficulty.NORMAL_10
    ],
    patch: ExpansionPatch.Patch_400,
    membersNeededForKill: CURRENT_TIER_RAID_KILLCOUNT,
    supportsFactions: false,
    supportsWorldFirstTracker: false,
    supportsGlobalCoverage: false,
    supportsGraphs: false,
    supportsTalentTrees: true,
    leaderboardByBestPull: true,
    approximateDifficultySize: true,
    disabledRegions: ['cn'],
    starts: {
      us: moment.utc('2024-05-30T22:00:00'),
      eu: moment.utc('2024-05-30T22:00:00'),
      tw: moment.utc('2024-05-30T22:00:00'),
      kr: moment.utc('2024-05-30T22:00:00'),
      cn: moment.utc('2024-05-30T22:00:00')
    },
    ends: FIRELANDS_RELEASE_DATES
  },
  {
    name: 'Throne of the Four Winds',
    short_name: 'TFW',
    slug: 'throne-of-the-four-winds',
    icon: 'achievement_boss_murmur',
    mapId: 754,
    tier: '11',
    ordinal: 5,
    numEncounters: 2,
    expansion: Expansion.Cataclysm,
    supportedDifficulties: [
      RaidDifficulty.HEROIC_25,
      RaidDifficulty.HEROIC_10,
      RaidDifficulty.NORMAL_25,
      RaidDifficulty.NORMAL_10
    ],
    patch: ExpansionPatch.Patch_400,
    membersNeededForKill: CURRENT_TIER_RAID_KILLCOUNT,
    supportsFactions: false,
    supportsWorldFirstTracker: false,
    supportsGlobalCoverage: false,
    supportsGraphs: false,
    supportsTalentTrees: true,
    leaderboardByBestPull: true,
    approximateDifficultySize: true,
    disabledRegions: ['cn'],
    starts: {
      us: moment.utc('2024-05-30T22:00:00'),
      eu: moment.utc('2024-05-30T22:00:00'),
      tw: moment.utc('2024-05-30T22:00:00'),
      kr: moment.utc('2024-05-30T22:00:00'),
      cn: moment.utc('2024-05-30T22:00:00')
    },
    ends: FIRELANDS_RELEASE_DATES
  },
  {
    name: 'The Ruby Sanctum',
    short_name: 'RS',
    slug: 'the-ruby-sanctum',
    icon: 'spell_shadow_twilight',
    mapId: 724,
    tier: '10',
    ordinal: 4,
    numEncounters: 1,
    expansion: Expansion.WrathOfTheLichKing,
    supportedDifficulties: [
      RaidDifficulty.HEROIC_25,
      RaidDifficulty.HEROIC_10,
      RaidDifficulty.NORMAL_25,
      RaidDifficulty.NORMAL_10
    ],
    patch: ExpansionPatch.Patch_340,
    membersNeededForKill: CURRENT_TIER_RAID_KILLCOUNT,
    supportsFactions: false,
    supportsWorldFirstTracker: false,
    supportsGlobalCoverage: false,
    supportsGraphs: false,
    supportsTalentTrees: true,
    leaderboardByBestPull: true,
    disabledRegions: ['cn'],
    starts: {
      us: moment.utc('2024-01-09T23:00:00'),
      eu: moment.utc('2024-01-09T23:00:00'),
      tw: moment.utc('2024-01-09T23:00:00'),
      kr: moment.utc('2024-01-09T23:00:00'),
      cn: moment.utc('2024-01-09T23:00:00')
    },
    ends: {
      us: moment.utc('2024-05-20T22:00:00'),
      eu: moment.utc('2024-05-20T22:00:00'),
      tw: moment.utc('2024-05-20T22:00:00'),
      kr: moment.utc('2024-05-20T22:00:00'),
      cn: moment.utc('2024-05-20T22:00:00')
    }
  },
  {
    name: 'Icecrown Citadel',
    short_name: 'ICC',
    slug: 'icecrown-citadel',
    icon: 'achievement_dungeon_icecrown_icecrownentrance',
    mapId: 631,
    tier: '10',
    ordinal: 3,
    numEncounters: 12,
    expansion: Expansion.WrathOfTheLichKing,
    supportedDifficulties: [
      RaidDifficulty.HEROIC_25,
      RaidDifficulty.HEROIC_10,
      RaidDifficulty.NORMAL_25,
      RaidDifficulty.NORMAL_10
    ],
    patch: ExpansionPatch.Patch_340,
    membersNeededForKill: CURRENT_TIER_RAID_KILLCOUNT,
    supportsFactions: false,
    supportsWorldFirstTracker: false,
    supportsGlobalCoverage: false,
    supportsGraphs: false,
    supportsTalentTrees: true,
    leaderboardByBestPull: true,
    disabledRegions: ['cn'],
    starts: {
      us: moment.utc('2023-10-12T22:00:00'),
      eu: moment.utc('2023-10-12T22:00:00'),
      tw: moment.utc('2023-10-12T22:00:00'),
      kr: moment.utc('2023-10-12T22:00:00'),
      cn: moment.utc('2023-10-12T22:00:00')
    },
    ends: {
      us: moment.utc('2024-05-20T22:00:00'),
      eu: moment.utc('2024-05-20T22:00:00'),
      tw: moment.utc('2024-05-20T22:00:00'),
      kr: moment.utc('2024-05-20T22:00:00'),
      cn: moment.utc('2024-05-20T22:00:00')
    }
  },
  {
    name: 'Ulduar',
    short_name: 'ULD',
    slug: 'ulduar',
    icon: 'achievement_dungeon_ulduarraid_misc_01',
    mapId: 603,
    tier: '8',
    ordinal: 1,
    numEncounters: 14,
    expansion: Expansion.WrathOfTheLichKing,
    supportedDifficulties: [RaidDifficulty.NORMAL_25, RaidDifficulty.NORMAL_10],
    patch: ExpansionPatch.Patch_320,
    membersNeededForKill: CURRENT_TIER_RAID_KILLCOUNT,
    supportsFactions: false,
    supportsWorldFirstTracker: false,
    supportsGlobalCoverage: false,
    supportsGraphs: false,
    supportsTalentTrees: true,
    leaderboardByBestPull: true,
    disabledRegions: ['eu', 'us', 'tw', 'kr'],
    // This is wrong dates, but we want them to be disabled (even though it still fills)
    starts: {
      us: moment.utc('2023-10-12T22:00:00'),
      eu: moment.utc('2023-10-12T22:00:00'),
      tw: moment.utc('2023-10-12T22:00:00'),
      kr: moment.utc('2023-10-12T22:00:00'),
      cn: moment.utc('2023-10-12T22:00:00')
    },
    ends: {
      us: moment.utc('2024-05-20T22:00:00'),
      eu: moment.utc('2024-05-20T22:00:00'),
      tw: moment.utc('2024-05-20T22:00:00'),
      kr: moment.utc('2024-05-20T22:00:00'),
      cn: moment.utc('2024-05-20T22:00:00')
    }
  }
];

const MAX_ALLOWED_ACTIVE_RAID = 4;

// Safety check
{
  const activeRaids = RAID_METADATA.filter((s) => s.ends.us === FAR_FUTURE_DATE).length;
  if (activeRaids > MAX_ALLOWED_ACTIVE_RAID) {
    throw new Error(`There's ${activeRaids} active raids where a maximum of ${MAX_ALLOWED_ACTIVE_RAID} is required.`);
  }
}
